<template>
  <div
      class="grm-video-layer one-fourth"
      :class="roomUserCountStyle"
      data-grm-comp="RoomCallCamstudyVideo.p2p"
      ref="roomCallVideo"
      :data-user-id="user.userId"
      :data-screen-share="user.screenShare"
  >
    <StopWatch :user="user"/>
    <!--  TODO: 화면 차단 영역 1:1 이미지로 변경 필요-->
    <div class="screen-block" v-show="isUserScreenBlock(user.userId)" v-html="$t('camstudy.videoStatus.blockScreen')"></div>
    <div class="relative w-full aspect-square"
         ref="roomVideoWrapper"
    >
      <div v-if="canvas" ref="canvasLayer"></div>
      <RoomVideo class="grm-video"
                 v-if="!canvas && stream"
                 ref="video"
                 :style="roomVideoStyle"
                 :muted="true"
                 :videoOnly="videoOnly"
                 :myVideo="isMe"
                 :user="user"
                 @resize="onRoomVideoResize"
                 @playing="onRoomVideoResize"
      ></RoomVideo>
      <CamstudyVideoControl
          :user="user"
          :pin="pin"
      ></CamstudyVideoControl>
      <!--
      <GrmDraggableResizable v-if="isMe && roomInfoSetting.useScreenMerger && localStream && isRoomMode('screenShare')"
                             :parent="true"
                             :w="screenSharePip.width"  :h="screenSharePip.height"
                             :x="screenSharePip.x"      :y="screenSharePip.y"
                             :lock-aspect-ratio="screenSharePip.lockAspectRatio"
                             :onResize="onResize"
                             :onDrag="onDrag"
      >
        <RoomVideo class="grm-video"
                   ref="localVideo"
                   :stream="localStream"
                   :style="roomVideoStyle"
                   :muted="isMuted"
                   :videoOnly="videoOnly"
        ></RoomVideo>
      </GrmDraggableResizable>
      -->

    </div>

    <div
        class="v-bg"
        v-if="!isScreenShare"
        :class="{
            'no-cam': !!roomUser && roomUser.roomUserRole.camera==false || roomUser.cameraStatus != 'on',
            'no-user': !roomUser
          }"
    >
      <img v-if="!roomUser" class="pointer-events-none"
           :style="{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
           }"
           :src="getUserImage"
      />
      <img v-if="!!roomUser && roomUser.roomUserRole.camera==false || roomUser.cameraStatus != 'on'" src="@/assets/images/camstudy/ico_no_cam.svg" alt="no_cam">
    </div>
    <div>
      <div @click="onOpenUserControl" class="control-event-area"></div>
      <div v-if="isOpenUserControl" class="user-control" @click.stop="onCloseUserControl">
        <div class="control-chat" @click="onOpenWhisperChat"></div>
        <div class="control-pin" :class="{active: pin}" @click="onPinMode"></div>
      </div>
    </div>

    <template v-if="!!roomUser">
      <div class="v-peakmeter" :class="{ active: roomUser && roomUser.isSpeaking && !isScreenShare }"></div>
<!--      <div class="v-dim" v-if="!isScreenShare"></div>-->
      <div class="v-user-info-area">
        <div class="v-name-area">
          <div class="v-name-img">
<!--            <img src="@/assets/images/user_profile.svg" />-->
            <UserProfileImage :user-id="roomUser.userId" class="profile-image" />
            <GrmIcon icon=""
                    v-if="hasEmceeRole(roomUser.userId)"
                    :class="hasSpeakerRole(roomUser.userId) ? 'room-speaker' : 'room-emcee'"
            />
          </div>
          <div class="v-name ep flex items-center justify-between" :class="{ isMe }" @click.stop>
            <p class="room-user-nickname min-w-0 max-w-max flex-1 truncate"
              v-tooltip.top="roomUser.nickname"
            >{{ roomUser.nickname }}</p>
            <div class="video-more-control" v-if="roomUserCount > 2" @click="onToggleVideoMoreControl"></div>
            <div v-if="roomUserCount <= 2 && isMe" class="video-flex-control-container">
              <div class="video-flex-control-container-item" :class="me.cameraStatus === 'on' ? 'camera-on' : 'camera-off'" @click="onToggleUserDeviceStatus"></div>
              <div class="video-flex-control-container-item camera-transition" v-show="isMobile"
                   @click="toggleCamera"
              ></div>
              <div class="video-flex-control-container-item study-certification" @click="onOpenStudyTimeSaveModal"></div>
            </div>
            <div v-if="roomUserCount <= 2 && !isMe" class="video-flex-control-container">
              <div class="video-flex-control-container-item chat" @click="onOpenWhisperChat"></div>
              <div class="video-flex-control-container-item pin" :class="{active: pin}" @click="onPinMode"></div>
              <div class="video-flex-control-container-item block" @click="blockUserScreen({userId: user.userId, block: !isUserScreenBlock(user.userId)})"></div>
              <div
                  v-if="hasEmceeRole() && !hasSpeakerRole(roomUser.userId)"
                  class="video-flex-control-container-item go-out" @click="() => {
                    isOpenKickOrBanUser = true
                    onCloseVideoMoreControl()
                  }">
              </div>
            </div>
            <div v-if="isOpenVideoMoreControl && isMe" class="video-more-control-container" v-click-outside="onCloseVideoMoreControl" :class="{isMe}">
              <div class="video-more-control-item" @click="onToggleUserDeviceStatus">
                <div class="video-more-control-icon camera"/>
                <div>{{ $t(`camstudy.control.camera.${me.cameraStatus === 'on' ? 'off' : 'on'}`) }}</div>
              </div>
              <div class="video-more-control-item" v-show="isMobile"
                   @click="toggleCamera"
              >
                <div class="video-more-control-icon camera-transition" />
                <div>{{ $t("camstudy.control.camera.rotate") }}</div>
              </div>
              <div class="video-more-control-item" @click="onOpenStudyTimeSaveModal">
                <div class="video-more-control-icon study-certification" />
                <div>{{ $t('camstudy.stopwatch.setting.saveImage') }}</div>
              </div>
            </div>
            <div v-else-if="isOpenVideoMoreControl && !isMe" class="video-more-control-container" v-click-outside="onCloseVideoMoreControl">
              <div class="video-more-control-item" @click="onOpenWhisperChat">
                <div class="video-more-control-icon chat" />
                <div>{{ $t('camstudy.chat.directMessage') }}</div>
              </div>
              <div class="video-more-control-item" @click="onPinMode">
                <div class="video-more-control-icon pin" :class="{active: pin}" />
                <div>{{ pin ? $t('camstudy.participant.unPin') : $t('camstudy.participant.pin') }}</div>
              </div>
              <div class="video-more-control-item" @click="blockUserScreen({userId: user.userId, block: !isUserScreenBlock(user.userId)})">
                <div class="video-more-control-icon block" />
                <div>
                  {{ isUserScreenBlock(user.userId) ? $t('camstudy.participant.unblockScreen') : $t('camstudy.participant.blockScreen') }}
                </div>
              </div>
              <div
                  v-if="hasEmceeRole() && !hasSpeakerRole(roomUser.userId)"
                  class="video-more-control-item" @click="() => {
                    isOpenKickOrBanUser = true
                    onCloseVideoMoreControl()
                  }">
                <div class="video-more-control-icon go-out" />
                <div>
                  {{ $t('camstudy.participant.kick') }}
                </div>
              </div>
            </div>
          </div>
          <KickOrBanUser v-if=" isOpenKickOrBanUser" :user="user" @close="()=> isOpenKickOrBanUser = false"/>
          <!--
          <div class="v-mic-off"
              v-if="(roomUser.micStatus === 'off' || roomUser.micStatus === 'none' || roomUser.roomUserRole.mic === false) && !isScreenShare"
          >
            <img src="@/assets/roomType/lms/img/icon_mic_off.svg" />
          </div>
          -->
        </div>
        <div class="v-user-determination">{{userMsg}}</div>
      </div>
      <RoomSticker class="absolute inset-0" :sticker-id="roomUser.stickerId" />
    </template>
    <RoomCallScreenShare v-if="user.screenShare" :userId="user.userId" />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import {GrmWebRTC} from '@/lib/gooroomee/webrtc/GrmWebRTC'
import RoomVideo from "@/components/Room/Call/RoomVideo";
import RoomCallScreenShare from '@/components/Room/Call/RoomCallScreenShare.vue'
import _ from "lodash";
import {RoomCall} from "@/core/api/room.call.api";
import GrmIcon from "@/components/Common/icon/GrmIcon";
import RoomSticker from "@/components/Room/Sticker/RoomSticker.vue";
import StopWatch from "@/components/Room/Camstudy/StopWatch.vue";
import CamstudyVideoControl from "@/components/Room/Camstudy/CamstudyVideoControl.vue";
import UserProfileImage from "@/components/Room/User/UserProfileImage.vue";
import CamstudyChatModal from "@/components/Room/Camstudy/control/Chat.vue";
import {Device} from "@/utils";
import CamStudySaveStudyImage from "@/components/Room/Camstudy/SaveStudyImage.vue"
import KickOrBanUser from "@/components/Room/Camstudy/KickOrBanUser.vue";
// import GrmDraggableResizable from "@/components/Common/draggableResizable/GrmDraggableResizable.vue";

export default {
  name: 'RoomCallCamStudyP2PVideo',
  components: {
    KickOrBanUser,
    UserProfileImage,
    CamstudyVideoControl,
    StopWatch,
    GrmIcon,
    RoomVideo,
    RoomSticker,
    RoomCallScreenShare,
    // GrmDraggableResizable,
  },
  props: {
    user: {
      type: Object,
      default: function(){
        return {
          userId: null,
          screenShare: false,
          _createdAt: 0
        };
      }
    },
    videoOnly: {
      type: Boolean,
      default: false
    },
    defaultVideoObjectFit: {
      type: String,
      default: ''
    },
    pin: {
      type: Boolean,
      default: false
    },
    isOpenUserControl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canvas: null,
      stream: null,
      localStream: null,
      screenSharePip: {
        x: 0,
        y: 0,
        width: 10,
        height: 10,
        minWidth: 1,
        lockAspectRatio: false,
      },
      videoObjectFit: undefined,
      isOpenVideoMoreControl: false,
      isOpenKickOrBanUser: false,
    }
  },

  created() {
    console.log('RoomCallVideo created : userId[%s], nickname[%s], screenShare[%s]',
        this.user?.userId, this.roomUser?.nickname,
        this.isScreenShare)
    this.$roomApi.addEventListeners((this._Events = _Events()), this)
  },

  mounted() {
    this.setStream();

    this.getDefaultView().addEventListener('resize', (this._w_resize=e => {
      clearTimeout(this._resizeTimer)
      this._resizeTimer = setTimeout(() => {
        this.onRoomVideoResize();
      }, 100)
    }));

    this.$emit('mounted', this);
  },

  destroyed() {
    this.$roomApi.removeEventListeners(this._Events)
    this.getDefaultView().removeEventListener('resize', this._w_resize);

    try{
      this.onRoomVideoResize({
        type: 'GrmDomIntersect',
        isIntersecting: false
      });
    }catch(e){
      console.warn(e);
    }

    this.$emit('destroyed', this);
  },

  computed: {
    ...mapGetters('user', [
      'me',
      'isOpener',
      'getRoomUser',
      'hasEmceeRole',
      'hasSpeakerRole',
      'isParticipantRole',
      'roomUserCount',
    ]),
    ...mapGetters('room', [
      'documentVisibilityState',
      'lowPowerMode',
      'isRoomMode',
      'deviceSettings',
      'isScreenShareMode',
      'roomInfoSetting',
      'isCamStudy'
    ]),
    ...mapGetters('call', [
      // 'getUserVideoStream',
      // 'getUserScreenStream'
    ]),
    ...mapGetters('ux', [
      'ux',
    ]),

    ...mapGetters('camstudy', [
        'getCamStudyUser',
        'isUserScreenBlock'
    ]),
    ...mapGetters('common', [
        'isOpenControlMenu',
    ]),
    userMsg() {
      return this.getCamStudyUser(this.user?.userId)?.myMsg
    },
    getUserImage(){
      return this.getCamStudyUser(this.user?.userId)?.profileImageUrl || require('@/assets/images/user_profile.svg')
    },
    roomUser() {
      let userId = this.user?.userId;
      if(!userId){
        return;
      }
      let roomUser = this.getRoomUser(userId);
      return roomUser;
    },
    isMe() {
      return this.roomUser && this.roomUser.userId === this.me.userId;
    },
    isMyScreenShareView() {
      return this.isRoomMode('screenShare') && this.isScreenShareMode;
    },
    isSpeakerOff(){
      return this.me.speakerStatus != 'on';
    },
    isMuted(){
      return this.isMe || this.isSpeakerOff;
    },
    roomVideoStyle() {
      if(this.isScreenShare){
        return{};
      }else{
        const style = {
          'transform': this.isMe && this.deviceSettings.video.usePreviewMirror
              ? 'scaleX(-1)' : '',
        }
        let videoObjectFit = this.videoObjectFit;
        if(videoObjectFit === undefined){
          videoObjectFit = this.defaultVideoObjectFit;
        }
        if(videoObjectFit){
          style.objectFit = videoObjectFit;
        }
        return style;
      }
    },
    isScreenShare() {
      // return !this.videoOnly
      //     && !!this.roomUser?.screenStatus;
      return !this.videoOnly
          && (!!this.user?.screenShare || !!this.user?.screenStatus);
    },
    isMobile(){
      return Device.isMobile()
    },
    roomUserCountStyle(){
      if(this.roomUserCount <= 1){
        return 'full'
      }else if(this.roomUserCount <= 42){
        return 'half'
      }else if(this.roomUserCount <= 4){
        return 'quarter'
      }
      return '';
    }
  },

  watch: {
    lowPowerMode: {
      handler: function(level) {
        this.onRoomVideoResize({}, {force: true})
      }
    },
    documentVisibilityState: {
      handler: function(state) {
        // if(state === 'visible'){
        // }
        this.onRoomVideoResize({}, {force: true})
      }
    },
    'user.userId': {
      // immediate: true,
      handler: function(userId, old) {
        if(!userId){
          this.stream = null;
          return;
        }
        this.setStream();
      }
    },
    'user.screenShare': {
      handler: function(screenShare, old){
        if(screenShare){
          console.log('RoomCallVideo screenShare :', screenShare)
        }
        this.setStream();
      }
    },
    stream: function(stream, prev) {
      if (!stream) {
        return;
      }
      // console.log('@@@@@@@@@@@@@@', this.user?.userId, stream === prev, stream, prev)
      this.$nextTick(async () => {
        await this.setStream(stream);
      })
    },
  },

  methods: {
    ...mapMutations('chat', [
        'SET_WHISPER_TARGET'
    ]),
    ...mapActions('room', [
      'toggleUserMixingVideoByUserId'
    ]),
    ...mapActions('call', [
      'getUserVideoStream',
      'getUserScreenStream',
      'resizeMergedStream',
      'moveMergedStream',
      'updateMergedScreenStream',
      'getStreamMergerMatrix',
      'getVideoOnlyStream',
      'changeVideoSenderMaxBitrateFromDomElement',
      'getP2PUserCurrentConnectionStats',
    ]),
    ...mapActions('roomGroup', [
      'setRoomUserGroup'
    ]),
    ...mapActions('common', [
        'openControlMenu',
        'closeControlMenu'
    ]),
    ...mapMutations('camstudy', [
      'blockUserScreen',
    ]),
    ...mapActions('user', [
      'toggleUserDeviceStatus',
    ]),
    onOpenUserControl: function(e){
      if(this.isOpenControlMenu && this.isMobile){
        return;
      }
      this.$emit('click', this.user.userId);
      e.stopPropagation()

      // this.onRoomVideoResize(e, {force: true});
      // (() => {
      //   if(this.isIntersecting === false) return;
      //   let video = this?.$refs?.video?.$refs?.video;
      //   if(!video || !video.paused || video.offsetWidth === 0) return;
      //   video.play().catch(e => {
      //     console.warn(e)
      //   });
      // })();
    },
    onCloseUserControl: function(e){
      this.$emit('click', this.user.userId);
    },
    onPinMode(e){
      this.$emit('onPinMode', this.user);

      this.onRoomVideoResize(e, {force: true});
      (() => {
        if(this.isIntersecting === false) return;
        let video = this?.$refs?.video?.$refs?.video;
        if(!video || !video.paused || video.offsetWidth === 0) return;
        video.play().catch(e => {
          console.warn(e)
        });
      })();

      if(this.isOpenVideoMoreControl){
        this.isOpenVideoMoreControl = false
      }
    },
    onOpenWhisperChat(){
      this.$modal(CamstudyChatModal, {once: true, exist: true})
      this.SET_WHISPER_TARGET(this.user.userId)
      this.openControlMenu()
      if(this.isOpenVideoMoreControl){
        this.isOpenVideoMoreControl = false
      }
    },
    setStream: async function(){
      const userId = this.user?.userId;
      let refs = {};

      this.localStream = null;
      if(userId){
        if(this.isScreenShare){
          this.stream = await this.getUserScreenStream({userId});
          if(this.isMe){
            refs.localVideo = this.localStream = await this.getUserVideoStream({userId});
          }
        }else{
          let stream = await this.getUserVideoStream({userId});
          // this.stream = await this.getVideoOnlyStream({stream});
          this.stream = stream;
        }
      }else{
        this.stream = null;
      }

      refs.video = this.stream;
      Object.entries(refs).forEach(([ref, stream])=>{
        const video = this.$refs[ref]?.$refs.video;
        if (!video) return;
        if (video.paused && video.srcObject) {
          video.play().catch(e => {
            if(!e.message || e.message.includes('interrupted')){
              return;
            }
            console.warn(video, e)
          });
        }

        if(!stream){
          console.warn('call stream is null', this.isScreenShare, this.user);
          video.srcObject = null;
          return;
        }

        if(video.srcObject === stream){
          return;
        }

        // console.log('video set stream : ', this.isScreenShare, this.user)

        function checkError(e){
          if(e.message.includes('aborted')){
            // 자동 재생 문제
            if(!video.muted){
              console.error(this.$t('call.error.autoplay'));
              return;
            }
          }else if(e.message.includes('interrupted by ')){
            // ignore
          }else{
            console.error(e);
          }
        }

        delete video._r_width;
        delete video._r_height;

        GrmWebRTC.attachMediaStream(video, stream)
        video.play().then(() => {
          this.onRoomVideoResize()
        }).catch(checkError);

        const vTrack = stream.getVideoTracks()[0];
        if(vTrack && vTrack.muted){
          this.onRoomVideoResize(null, {immediate: true})
        }
      })
    },
    async updatePipLocation(){
      await this.updateMergedScreenStream();

      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if(!roomVideoWrapper) return;

      const {clientWidth, clientHeight} = roomVideoWrapper;
      const {canvasRatioX, canvasRatioY, canvasRatioWidth, canvasRatioHeight} = await this.getStreamMergerMatrix();

      this.screenSharePip.lockAspectRatio =  false;
      this.screenSharePip.x = clientWidth * canvasRatioX;
      this.screenSharePip.y = clientHeight * canvasRatioY;
      this.screenSharePip.width = clientWidth * canvasRatioWidth;
      this.screenSharePip.height = clientHeight * canvasRatioHeight;
      this.$nextTick(() => {
        this.screenSharePip.lockAspectRatio =  true;
      });

    },
    async onRoomVideoResize(e, options={immediate: false, force: false}) {
      const changeVisible = e?.type === 'GrmDomIntersect' && !this.isIntersecting && e.isIntersecting;

      // intersecting 값 관련하여 최초에 설정해야 함. 위치 고정.
      if(e?.type === 'GrmDomIntersect') {
        this.isIntersecting = e.isIntersecting;
      }

      // ch bandwidth method / debounce
      (() => {
        this._chBandWidth = this._chBandWidth || function({videoWidth, videoHeight, bitrate, framerate, degradationPreference}, timer){
          let data = {
            userId: this.user.userId,
            el: this.$el,
            videoWidth, videoHeight, bitrate, framerate, degradationPreference
          }
          // console.trace('@@@@@@@@@@@@ s2', e?.type, this.$el, data);
          if(!this.user.screenShare){
            // RoomCall.changeVideoSenderMaxBitrate(data)
            this.changeVideoSenderMaxBitrateFromDomElement(data);
          }else{
            this.changeVideoSenderMaxBitrateFromDomElement({
              userId: this.user.userId,
              el: this.$el,
              bitrate: 0
            });
            RoomCall.changeSecondVideoSenderMaxBitrate(data)
          }

          // check bandwidth
          (() => {
            if(this.isMe || !changeVisible || bitrate <= 10){
              return;
            }

            const checkTimer = (loop) => {
              loop = (loop || 0)+1;
              clearTimeout(this._timer_video_monitor);
              this._timer_video_monitor = setTimeout(async () => {
                if(!this.$el?.isConnected || !this.isIntersecting) return;
                const ru = this.roomUser;
                if(!ru) return;
                const connStats = await this.getP2PUserCurrentConnectionStats(ru.userId);
                if(!connStats){
                  checkTimer(loop);
                  return;
                }

                let bw = connStats.video?.receive?.availableBandwidthKbps || 0;
                if(bw < 5){
                  console.warn('wrong video bw: userId[%s], name[%s], bw[%s] -> req[%s], loop[%s]', ru.userId, ru.nickname, bw, bitrate, loop);
                  this._chBandWidth({videoWidth, videoHeight, bitrate, framerate, degradationPreference}, false)
                  if(loop > 10){
                    return;
                  }
                  checkTimer(loop);
                }else if(loop <= 2){
                  checkTimer(loop);
                }
              }, 1000*5);
            };
            if(timer !== false){
              checkTimer();
            }
          })();
        };
        this._chBandWidthDebounce = this._chBandWidthDebounce || _.debounce(({videoWidth, videoHeight, bitrate, framerate, degradationPreference}) => {
          // console.trace('@@@@@@@@@@@@ s1', e.type, this.user.userId, {videoWidth, videoHeight, bitrate, framerate, degradationPreference});
          this._chBandWidth({videoWidth, videoHeight, bitrate, framerate, degradationPreference});
        }, 100);
      })();

      let video = this?.$refs?.video?.$refs?.video;
      if (this.isIntersecting && video && video.paused && video.srcObject) {
        video.play().catch(e => {
          if(!e.message || e.message.includes('interrupted')){
            return;
          }
          console.warn(video, e)
        });

      }

      // // fit video
      // if(this.isIntersecting && video && !video.paused){
      //   let width = Math.abs(video.videoWidth - this.$el.offsetWidth);
      //   let height = Math.abs(video.videoHeight - this.$el.offsetHeight);
      //   let ratio = video.videoWidth > 0 && video.videoWidth / video.videoHeight;
      //   if((width > 0 && width < 4) || (height > 0 && height < 4) && ratio > 1){
      //     this.videoObjectFit = 'cover';
      //   }else{
      //     this.videoObjectFit = 'contain';
      //   }
      // }

      video = video || this.$refs.roomVideoWrapper;
      if (!video){
        this._chBandWidthDebounce.cancel();
        this._chBandWidth({
          videoWidth:0, videoHeight:0,
          bitrate:0, framerate:1
        });
        return;
      }

      this.resizeRoomVideoWrapper();
      if (this.isScreenShare) {
        if (this.roomInfoSetting.useScreenMerger && this.isMe) {
          return this.updatePipLocation();
        }
      }

      // console.log('@@@@ resize event :', e, options)
      if(e?.type === 'GrmDomIntersect'){
        if(!e.isIntersecting){
          video._r_width = video._r_height = 0;
          this._chBandWidthDebounce({bitrate:0, framerate:1});
          return;
        }
      }else{
        if(this.isIntersecting === false){
          return;
        }
      }

      const videoWidth = video.offsetWidth, videoHeight = video.offsetHeight;
      if(options.force !== true){
        if(video._r_width == videoWidth && video._r_height == videoHeight){
          return;
        }
      }
      video._r_width = videoWidth;
      video._r_height = videoHeight;

      let bitrate = 128, framerate = 20, degradationPreference = 'balanced';
      if(videoWidth <= 100){
        bitrate = 100;
        framerate = 10;
      }else if(videoWidth <= 200){
        bitrate = 128;
        framerate = 13;
      }else if(videoWidth <= 320){
        bitrate = 160;
        framerate = 15;
      }else if(videoWidth <= 400){
        bitrate = 256;
        framerate = 15;
      }else if(videoWidth < 640){
        bitrate = 382;
        framerate = 15;
      }else if(videoWidth <= 1024){
        bitrate = 512;
      }else if(videoWidth < 1280){
        bitrate = 768;
      }else{
        bitrate = 1024;
      }

      if(screen.width > 1920){
        bitrate *= (1920 / screen.width * 1.2);
      }
      if(this.isCamStudy){
        let lowPowerMode = this.lowPowerMode;
        if(lowPowerMode > 0){
          bitrate = 20;
          framerate = Math.min(framerate, 4);
          degradationPreference = 'maintain-framerate'

          if(lowPowerMode > 1){
            bitrate = 10;
            framerate = Math.min(framerate, 3);
          }
        }else{
          let minBitrate = 50;
          bitrate = Math.max(bitrate / 2.5, minBitrate);
          framerate = Math.min(framerate, 5);
        }
        if(document.visibilityState === 'hidden'){
          bitrate = 0;
        }
      }

      if(options?.immediate === true){
        this._chBandWidthDebounce.cancel();
        this._chBandWidth({videoWidth, videoHeight, bitrate, framerate, degradationPreference});
      }else{
        this._chBandWidthDebounce({videoWidth, videoHeight, bitrate, framerate, degradationPreference});
      }
    },
    onResize(handle, x, y, width, height){
      if(!this.roomInfoSetting.useScreenMerger) return

      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if(!roomVideoWrapper) return;

      const {clientWidth, clientHeight} = roomVideoWrapper;
      this.resizeMergedStream({
        ratioX: x / clientWidth,
        ratioY: y / clientHeight,
        ratioWidth: width / clientWidth,
      })
    },
    onDrag(x, y){
      if(!this.roomInfoSetting.useScreenMerger) return

      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if(!roomVideoWrapper) return;

      const {clientWidth, clientHeight} = roomVideoWrapper;
      this.moveMergedStream({
        ratioX: x / clientWidth,
        ratioY: y / clientHeight
      })
    },
    resizeRoomVideoWrapper() {
      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if (!this.isScreenShare) {
        if(roomVideoWrapper){
          roomVideoWrapper.style.width = roomVideoWrapper.style.height = null
        }
        return
      }

      const roomCallVideo = this.$refs?.roomCallVideo;
      const roomCallVideoRatio = roomCallVideo.clientWidth / roomCallVideo.clientHeight;

      const video = this?.$refs?.video?.$refs?.video;
      const videoTrackSettings = video.srcObject.getVideoTracks()[0].getSettings();
      const videoTrackRatio = videoTrackSettings.width / videoTrackSettings.height;

      // if (videoTrackRatio === 16 / 9) {
      //   return;
      // }

      roomVideoWrapper.style.width = videoTrackRatio >= roomCallVideoRatio ? '100%' : 'auto';
      roomVideoWrapper.style.height = videoTrackRatio > roomCallVideoRatio ? 'auto' : '100%';
    },
    onToggleVideoMoreControl(){
      this.isOpenVideoMoreControl = !this.isOpenVideoMoreControl;
      this.closeControlMenu()
    },
    onCloseVideoMoreControl(){
      this.isOpenVideoMoreControl = false;
    },
    onOpenStudyTimeSaveModal(){
      this.$modal(CamStudySaveStudyImage, {once: true, data: {fade: false, fadeOpacity: true}})
      this.onCloseVideoMoreControl()
    },
    isEnableDevice(){
      return (deviceType) => {
        if(!deviceType) return;

        const {roomUserRole} = this.me;
        if(!roomUserRole) return;

        return roomUserRole[deviceType];
      }
    },
    onToggleUserDeviceStatus(){
      if(this.isEnableDevice('camera')){
        this.toggleUserDeviceStatus({deviceType: 'camera'})
      }
    },
    // video preview TODO: CamstudyPreview 메소드 중 일부만 갖고옴
    ...(function(){
      return {
        ...mapActions('call', [
          'getLocalDeviceSetting', 'saveLocalDeviceSetting',
          'changeUserDevice'
        ]),
        async saveVideoDevice (video) {
          if(!video?.deviceId) return
          this.saveLocalDeviceSetting({
            video
          });

          // await this.stopMediaStream();
          this.changeUserDevice({deviceType: 'video', deviceId: video.deviceId});
        },
        async getVideoDevices () {
          const devices = await GrmWebRTC.getUserDevice();
          const videos = devices.videoinput.map(device => device.toJSON());
          if(videos.length === 0) return videos;

          if(!videos[0].label){
            try{
              const stream = await GrmWebRTC.getUserMedia({video: true});
              stream.getTracks().forEach(t => t.stop());
            }catch(e){
              console.error(e);
            }
          }
          return videos;
        },
        async toggleCamera (selectedDeviceId) {
          // if(this.cameraOff) {
          //   return
          // }
          let stream = this.$roomApi.Call.Stream.getCurrentPreviewStream()
          stream = this.$roomApi.Call.Stream.getVideoOnlyStream({stream});
          const videoTrack = stream?.getVideoTracks()[0];
          let currentVideoId = videoTrack?.GrmTrack?.getDeviceId() || videoTrack?.getSettings().deviceId;
          let currentDeviceIndex = -1;

          let devices = await this.getVideoDevices();
          const videos = devices
              .reduce((data, device, idx) => {
                data.list.push(device);
                if(device.deviceId === currentVideoId){
                  currentDeviceIndex = idx;
                }
                let label = device.label.toLowerCase();
                if(
                    label.includes('전면') || label.includes('front')
                ){
                  data.front.push(device);
                }else if(
                    label.includes('후면') || label.includes('back')
                ){
                  data.back.push(device);
                }
                return data;
              }, {
                front: [], back: [], list: []
              });

          let changeDevice;
          if(videos.front.length > 0 && videos.back.length > 0){
            [videos.front, videos.back].forEach(arr => {
              arr.sort((a,b) => a.label.localeCompare(b.label));
            });
            if (currentVideoId === videos.front[0].deviceId) {
              changeDevice = videos.back[0];
            } else {
              changeDevice = videos.front[0];
            }
          }else{
            let idx = currentDeviceIndex + 1;
            if(idx+1 >= videos.list.length){
              idx = 0;
            }
            changeDevice = videos.list[idx];
          }
          if(!changeDevice) return;
          if(changeDevice.deviceId === currentVideoId) return;

          this.saveVideoDevice(changeDevice);
        },
      }
    }()),
  }
}

function _Events(){
  return {
    room_call_loadLocalStreamStart: function() {
      if (!this.isMe) return
    },
    room_call_loadLocalStream: function(e) {
      if (!this.isMe) return
      // this.stream = e.data.stream;
      this.setStream();
    },
    room_core_call_changeUserStream: function(e) {
      if (!this.isMe) return
      const {stream} = e.data;
      if(this.stream.getVideoTracks()[0] !== stream.getVideoTracks()[0]) {
        this.setStream();
      }
    },
    room_call_loadScreenShareStream: function(e) {

    },
    room_call_userConnectionConnected: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
      this.setStream();
    },
    room_call_userConnectionDisconnected: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
    },
    room_call_userVideoStream: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
      if(this.isScreenShare){
        return;
      }
      this.setStream();
    },
    room_call_userSecondStream: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
      if(!this.isScreenShare){
        return;
      }
      this.setStream();
    },
    room_call_screenShare: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
      this.setStream();
    }
  }
}
</script>

<style scoped lang="scss">
.grm-video-layer {
  line-height: 1.5;
  padding: 5px;
  @media(orientation: portrait){
    width: 50% !important;
    &.full{
      width: 100% !important;
      max-width: 719px;
    }
  }
  @media(orientation: landscape){
    width: 25% !important;
    &.full{
      width: auto !important;
      height: calc(100dvh - 270px) !important;
      max-width: none !important;
      aspect-ratio: 0.93 / 1;
    }
    &.half{
      width: 100% !important;
      max-width: 466px;
    }
    &.quarter{
      width: 50% !important;
    }
    max-width: 319px;
    scroll-snap-align: start;
  }
  //position: absolute !important;
  box-sizing: border-box !important;
  margin: 0 0 20px !important;

  &[draggable="true"] {
    &.no-user{
      cursor: default;
    }
    cursor: grab;
  }

  .grm-video {
    //width: 100%;
    //height: 100%;
    aspect-ratio: 1 / 1;
    width: inherit;
    height: inherit;
    pointer-events: none;
  }
  .fitVideo {
    object-fit: cover;
  }

  .grm-video-layer-border {
    //position: absolute;
    //left: 0;
    //top: 0;
    z-index: 1;
    margin: 0;
    border-bottom: 1px solid #0c0c0c;
    border-right: 1px solid #0c0c0c;
    box-sizing: border-box;
    pointer-events: none;
  }

  .v-peakmeter {
    pointer-events: none;
  }

  .video-del {
    z-index: 1;
  }
}

.one-fourth {
  position: relative;
  //background-color: #394050;

  &.sub-video{
    cursor: pointer;
  }
  *{
    //pointer-events: none;
  }
  .network-off {
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .v-bg {
    width: calc(100% - 10px);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 5px;
    aspect-ratio: 1/1;
    left: 5px;

    &.no-user {
      background-color: #394050;
    }

    &.no-cam {
      background: linear-gradient(180deg, #121212 0%, #313131 100%);
      border-radius: 12px;
    }
  }

  .v-dim {
    position: absolute;
    left: 0;
    right: 0;
    height: 16%;
    min-height: 40px;
    bottom: 0;
    background: linear-gradient(
            360deg,
            rgba(0, 0, 0, 0.4) 0%,
            rgba(0, 0, 0, 0) 100%
    );
  }

  .v-peakmeter {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid $mainColor;
    z-index: 1;
    opacity: 0;
    transition: 0.2s ease-out;
    &.active {
      opacity: 1;
    }
  }

  .v-user-info-area {
    position: static;
    width: 100%;
    margin-top: 6px;
    padding: 6px;
  }

  .v-name-area {
    display: flex;
    //bottom: 0px;
    box-sizing: border-box;
    text-align: left;

    .v-name-img {
      position: relative;
      width: 24px;
      height: 24px;

      .profile-image {
        width: 100%;
        height: 100%;
        border-radius: 100%;
        overflow: hidden;
      }

      .room-speaker {
        position: absolute;
        right: -6px;
        bottom: -6px;
        width: 14px;
        height: 14px;
        border-radius: 6px;
        background: #FF7F00 url('~@/assets/images/crown_white.svg') no-repeat center / auto 72%;
        // background: white url('~@/assets/images/crown_blue.svg') no-repeat center / auto 80%;
        box-sizing: content-box;
        border: 2px solid #1F1F1F;
      }
      .room-emcee {
        position: absolute;
        right: -6px;
        bottom: -6px;
        width: 14px;
        height: 14px;
        border-radius: 6px;
        background: #666666 url('~@/assets/images/crown_white.svg') no-repeat center / auto 72%;
        // background: white url('~@/assets/images/crown_blue.svg') no-repeat center / auto 80%;
        box-sizing: content-box;
        border: 2px solid #1F1F1F;
      }
    }

    .v-name {
      min-width: 0;
      flex: 1;
      margin-left: 8px;
      font-size: 12px;
      font-weight: bold;
      color: white;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .speaker-img {
        width: 15px;
        height: 15px;
        vertical-align: -2px;
      }

      &.isMe {
        //color: #fff700;
      }
    }

    .v-mic-off {
      width: 20px;
      height: 20px;
    }
  }

  .v-user-determination {
    margin-top: 10px;
    text-align: left;
    font-size: 12px;
    color: white;
    line-height: 100%;    
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
  }

  .video-del {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    display: none;
  }

  .room-user-nickname {
    pointer-events: auto;
  }
}

.one-fourth.column:hover .video-del {
  display: block;
}

.v-participation {
  position: absolute;
  top: 60%;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: .4;
  z-index: 1;
}
.screen-block {
  position: absolute;
  top: 5px;
  left: 5px;
  width: calc(100% - 10px);
  aspect-ratio: 1 / 1;
  pointer-events: none;
  border-radius: 12px;
  background: linear-gradient(180deg, #121212 0%, #313131 100%);

  display: flex;
  justify-content: center;
  align-items: center;

  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;

  //background: #102132 url('~@/assets/images/camstudy/video_view_block.svg') center no-repeat !important;
  z-index: 3;
}
.control-event-area{
  position: absolute;
  width: 70%;
  aspect-ratio: 1 / 1;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}
.user-control{
  background: #00000080;
  width: calc(100% - 10px);
  display: flex;
  justify-content: center;
  border-radius: 12px;
  align-items: center;
  position: absolute;
  top: 5px;
  aspect-ratio: 1/1;
  left: 5px;
  gap: 12px;

  .control-chat{
    width: 24px;
    height: 24px;

    background: url("~@/assets/images/camstudy/control_chat.svg") no-repeat center;
    background-size: auto 24px;
  }
  .control-pin{
    width: 24px;
    height: 24px;

    background: url("~@/assets/images/camstudy/ico_pin_active.svg") no-repeat center;

    &.active{
      background: url("~@/assets/images/camstudy/ico_pin_inactive.svg") no-repeat center;
    }
  }
}
.video-more-control{
  width: 24px;
  height: 24px;
  background: url("~@/assets/images/camstudy/ico_more_gray.svg") no-repeat center;
  cursor: pointer;
}

.video-flex-control-container{
  display: flex;
  align-items: center;
  gap: 12px;

  .video-flex-control-container-item{
    width: 36px;
    height: 36px;
    border-radius: 18px;

    &.camera-on{
      background: #313131 url("~@/assets/images/camstudy/control_camera.svg") no-repeat center;
    }
    &.camera-off{
      background: #313131 url("~@/assets/images/camstudy/control_camera_inactive.svg") no-repeat center;
    }
    &.camera-transition{
      background: #313131 url("~@/assets/images/camstudy/ico_camera_transition.svg") no-repeat center;
    }
    &.study-certification{
      background: #313131 url("~@/assets/images/camstudy/ico_save_study_white.svg") no-repeat center;
    }
    &.chat{
      background: #313131 url("~@/assets/images/camstudy/control_chat.svg") no-repeat center;
    }
    &.block{
      background: #313131 url("~@/assets/images/camstudy/ico_block_white.svg") no-repeat center;
    }
    &.go-out{
      background-position: center center;
      background-color: #313131;
      background-image: url('~@/assets/images/camstudy/control_out.svg');
      background-repeat: no-repeat;
    }
    background-size: auto 18px !important;
    &.pin{
      background: #313131 url("~@/assets/images/camstudy/ico_pin_active.svg") no-repeat center;
      background-size: auto 24px !important;

      &.active{
        background: #313131 url("~@/assets/images/camstudy/ico_pin_inactive.svg") no-repeat center;
      }
    }
  }
}

html:not([grm-device-mobile]){
  .video-more-control-container{
    position: absolute;
    right: 0;
    transform: translateY(82px);
    width: 180px;
    padding: 8px 0;
    border-radius: 6px;
    z-index: 3;

    &.isMe{
      transform: translateY(64px);
    }

    .video-more-control-item {
      height: 36px;
      padding: 8px 20px;
      font-size: 14px;
      font-weight: 400;

      .video-more-control-icon{
        width: 18px;
        height: 18px;
      }
    }
  }
}
[grm-device-mobile]{
  .video-more-control-container{
    position: fixed;
    bottom: 8px;
    @media(orientation: portrait){
      left: 8px;
      right: 8px;
    }
    @media(orientation: landscape){
      left: 50%;
      transform: translateX(-50%);
      max-width: 360px;
      width: 100%;
    }
    padding: 12px 0;
    z-index: 1000;
    border-radius: 12px;
    .video-more-control-item {
      height: 48px;
      padding: 12px 20px;
      font-size: 14px;
      font-weight: 400;

      .video-more-control-icon{
        width: 24px;
        height: 24px;

        background-size: auto 24px !important;
        &.pin{
          background-size: auto 32px !important;
        }
      }
    }
  }
}
.video-more-control-container{
  background: #313131;

  .video-more-control-item{
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;

    .video-more-control-icon{
      &.camera{
        background: url("~@/assets/images/camstudy/control_camera.svg") no-repeat center;
      }
      &.camera-transition{
        background: url("~@/assets/images/camstudy/ico_camera_transition.svg") no-repeat center;
      }
      &.study-certification{
        background: url("~@/assets/images/camstudy/ico_save_study_white.svg") no-repeat center;
      }
      &.chat{
        background: url("~@/assets/images/camstudy/control_chat.svg") no-repeat center;
      }
      &.block{
        background: url("~@/assets/images/camstudy/ico_block_white.svg") no-repeat center;
      }
      &.go-out{
        background-position: top center;
        background-image: url('~@/assets/images/camstudy/control_out.svg');
      }
      background-size: auto 18px !important;
      &.pin{
        background: url("~@/assets/images/camstudy/ico_pin_active.svg") no-repeat center;
        background-size: auto 24px !important;

        &.active{
          background: url("~@/assets/images/camstudy/ico_pin_inactive.svg") no-repeat center;
        }
      }
    }
  }
}
</style>